import 'styles/templates/giving-back.scss'

import 'scripts/vue/main'
import Vue from 'vue'

window.PSTheme.Vue.GivingBack = new Vue({
  name: 'GivingBack',
  components: {
    'donations': require('scripts/vue/components/Donations.vue').default
  }
}).$mount('.giving-back__donation')
